import {
  CPSConfig,
  CPSConfigFunctionnality,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P00039DataRxTxIndex } from './P00039Sync';
import { P0003602FunctionFinish } from './P0003602/Installation/P0003602InstallationFinish';
import { P0003602FunctionReset } from './P0003602/Installation/P0003602InstallationReset';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P0003602NCCMiseEnOeuvreInit } from './P0003602/NCC/miseenoeuvre/P0003602NCCMiseEnOeuvreInit';

export class P0003602Data {
  ncCConfirmationOTA: number = 0;

  ncCResetProtectionMagnetique: number = 0;

  ncCResetProtectionThermique: number = 0;

  ncCResetUsine: number = 0;

  ncCCommandePompe: number = 0;

  ncPDureeTemporisation: number = 0;

  ncIConfigurationProduit: number = 0;

  ncIActivationProtectionThermique: number = 0;

  ncIActivationProtectionMagnetique: number = 0;

  ncICourantNominalPompe: number = 0;

  ncSAlarme: number = 0;

  ncSCommandePompe: number = 0;

  ncSEtatPompe: number = 0;

  ncSEtatProtectionMagnetique: number = 0;

  ncSEtatProtectionThermique: number = 0;

  ncSEtatBouton: number = 0;

  ncSCompteARebours: number = 0;

  ncSCourantConsommePompe: number = 0;

  ncSNombreCommutationRelais: number = 0;

  ncSTensionSecteur: number = 0;

  ncSPuissanceApparente: number = 0;

  ncSPuissanceActive: number = 0;

  ncSCompteurPuissanceApparenteTotale: number = 0;

  ncSCompteurPuissanceActiveTotale: number = 0;

  ncSCompteurAmpereHeure: number = 0;

  ncSTempsSousTension: number = 0;

  ncSCompteurBouton: number = 0;

  ncSCompteurResetUsine: number = 0;

  ncSCompteurResetManuelProtectionMagnetique = 0;

  ncSCompteurResetManuelProtectionThermique = 0;
}

export class P0003602 extends IProduct {
  override deviceTableIndex: number = 18;

  override modelIdentifier?: string = 'P00036-02';

  override dataIdentifier?: string = 'P0003602';

  override manufacturerName?: string = 'ACWA';

  data: P0003602Data = new P0003602Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P0003602/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P0003602/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P0003602/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P0003602;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P0003602?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P0003602.tuto.installation.help.title',
      helpSlides: [
        'P0003602.tuto.installation.help.1',
        'P0003602.tuto.installation.help.2',
        'P0003602.tuto.installation.help.3',
        'P0003602.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003602/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0003602/installation-1_dark.png',
          },
          text: 'P0003602.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003602/installation-2.png',
            dark: '/assets/ecosystem/images/products/P0003602/installation-2_dark.png',
          },
          text: 'P0003602.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003602/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0003602/installation-1_dark.png',
          },
          text: 'P0003602.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P0003602/update-2.png',
            dark: '/assets/ecosystem/images/products/P0003602/update-2_dark.png',
          },
          text: 'P0003602.tuto.update.page2',
        },
      ],
    };
  }

  // @ts-ignore
  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          /*{
            component: P0003602InstallationSurpresseur, condition: () => {
              return true;
            },
          },*/
        ],
        finish: P0003602FunctionFinish,
        reset: P0003602FunctionReset,
      },
      controlCards: [
        //{ component: P0003602CardNccControle, weight: 8 },
      ],

      statusCards: [
        //{ component: P0003602CardNccStatut, weight: 26 },
      ],

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.NCC];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality,
  ): CPSConfigFunctionnality | null {
    if (functionnality == IProductFunctionnality.NCC) {
      return {
        miseEnOeuvre: {
          pages: [
            //{ component : P0003602NCCMiseEnOeuvreTemporisation, condition: () => { return true; } },
          ],
          init: P0003602NCCMiseEnOeuvreInit,
        },

        controle: {
          enabledUser: true,
          enabledSupport: true,

          //component: P0003602NccControle,
        },
        parametrages: {
          enabledUser: true,
          enabledSupport: true,

          reglage: {
            enabledUser: true,
            enabledSupport: true,
            //component: P0003602NccParameters,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          //component: P0003602NccStatut,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            //component: P0003602NccHistoriqueSuivi,
          },
        },
      };
    }
    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.NCC_Controle,
      propertyName: 'ncCConfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 19;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).ncIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.csv'
    );
  }
}
